import React from "react";

export const MultiLineEllipsis = ({ clamp = 3, children, className = "" }) => {
  return (
    <div
      className={["line-clamp", className].filter(Boolean).join(" ")}
      style={{ "--line-clamp": String(clamp) }}
    >
      {children}
    </div>
  );
};

export default MultiLineEllipsis;
